export default class LoadingActions {
    static LOADING:string = "LOADING";
}